const production = true;
const devApiBasePath = "https://api-voulez-vous.cloudsource.ge";

export const environment = {
  version: "0.40",
  beta: false,
  videosPath: "https://videos.voulez-vous.ge",
  basePathNoPort: production
    ? "https://api.voulez-vous.ge"
    : devApiBasePath,
  basePath: production ? "https://api.voulez-vous.ge" : devApiBasePath,
  imagePath: production
    ? "https://api.voulez-vous.ge"
    : "https://api.voulez-vous.ge",
  remoteAddr: "http://194.233.168.68",
  apiKey: "app_key",
  apiSecret: "app_secret",
  GooleMapsKey: "AIzaSyBqwF8rkrutCvJBq90YW7w1idb7uYMnQuM",
  imagesPath: "static/images",
  allowedDocumentFormats: [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "image/png",
    "image/jpeg",
  ],
  holidayDayEnd : '2026-01-05',
  eGiftCardId: "636fb2fbef78a0fcdb803766",
  giftCardId: "636fb2fbef78a0fcdb803767",
  facebookAPPID: "4637882839764528",
  googleClientID: "500110630087-d5vn3r6tv1mn745rsh1mgkuipk31kksh.apps.googleusercontent.com",
  googlePayEnvironment: "TEST",
  googlePayGateway: "georgiancard",
  googlePayGatewayMerchantId: "BCR2DN4TXKPITITV",
  googlePayMerchantName: "Voulez-Vous",
  giftCardOptions: [20, 50, 80, 100, 200, 500, 1000, 1500],
  company: {
    phoneNumber: "237 22 72",
  },
  params: [
    "age_range",
    "benefits",
    "brand",
    "category",
    "cellulite_and_strech_marks",
    "color_family",
    "concerns",
    "coverage",
    "finish",
    "formulation",
    "color",
    "ingredient_preferences",
    "foundation",
    "fragrance_family",
    "fragrance_type",
    "p_category",
    "size",
    "tag",
    "skin_type",
    "sun_protection",
    "price"
  ],
  filterType: "accordion",
};
